import React from "react";

export type THourglassIconProps = React.SVGAttributes<SVGElement>;

export function HourglassIcon({ fill = 'currentColor', ...rest }: THourglassIconProps) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...rest}>
      <mask id="mask0_2440_5779" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
        <rect width="26" height="26" fill={fill} />
      </mask>
      <g mask="url(#mask0_2440_5779)">
        <path d="M9 21H17V18C17 16.9 16.6083 15.9583 15.825 15.175C15.0417 14.3917 14.1 14 13 14C11.9 14 10.9583 
        14.3917 10.175 15.175C9.39167 15.9583 9 16.9 9 18V21ZM13 12C14.1 12 15.0417 11.6083 15.825 10.825C16.6083 
        10.0417 17 9.1 17 8V5H9V8C9 9.1 9.39167 10.0417 10.175 10.825C10.9583 11.6083 11.9 12 13 12ZM5 23V21H7V18C7 
        16.9833 7.2375 16.0292 7.7125 15.1375C8.1875 14.2458 8.85 13.5333 9.7 13C8.85 12.4667 8.1875 11.7542 7.7125 
        10.8625C7.2375 9.97083 7 9.01667 7 8V5H5V3H21V5H19V8C19 9.01667 18.7625 9.97083 18.2875 10.8625C17.8125 11.7542 
        17.15 12.4667 16.3 13C17.15 13.5333 17.8125 14.2458 18.2875 15.1375C18.7625 16.0292 19 16.9833 19 
        18V21H21V23H5Z" fill={fill} />
      </g>
    </svg>

  );
}
